import { useAuthStore } from "@/store/auth.store";
import { useEffect } from "react";
import { useStripeGetSession } from "@/hooks/stripe/useStripeGetSession";
import { SetupSubscription } from "./components/SetupSubscription";
import ManageSubscription from "./components/ManageSubscription";
import { ParagraphSkeleton } from "@/components/ui/skeleton/ParagraphSkeleton";
import { StripeCustomerSessionType } from "@/common/enums/enums";

export default function SubscriptionSettings(): JSX.Element {
  const { userData } = useAuthStore.getState();
  const { result: stripeSession, fetch: getSession } = useStripeGetSession();

  useEffect(() => {
    if (userData) {
      void getSession(userData.email);
    }
  }, [userData, getSession]);

  if (stripeSession?.type == StripeCustomerSessionType.CUSTOMER_SESSION) {
    return <SetupSubscription stripeSession={stripeSession} />;
  }

  if (stripeSession?.type == StripeCustomerSessionType.BILLING_SESSION) {
    return <ManageSubscription stripeSession={stripeSession} />;
  }

  return <ParagraphSkeleton lines={4} />;
}
